import { Link } from 'react-router';

export default function Footer() {
  return (
    <footer className="relative z-10 bg-bg-primary border-t border-border-primary">
      <div className="max-w-[1400px] mx-auto section-padding py-16 md:py-20">
        {/* Top grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {/* Column 1: Logo */}
          <div>
            <div className="mb-4">
              <img
                src="/straton-logo.svg"
                alt="Straton Group"
                className="h-5 w-auto brightness-0 invert"
              />
            </div>
            <p className="body-sm">Industrial Automation Specialists</p>
          </div>

          {/* Column 2: Nav */}
          <div className="flex flex-col gap-3">
            <span className="label-small mb-2">NAVIGATION</span>
            <Link to="/" className="body-sm hover:text-text-primary transition-colors duration-300">Home</Link>
            <Link to="/about" className="body-sm hover:text-text-primary transition-colors duration-300">About</Link>
            <Link to="/solutions" className="body-sm hover:text-text-primary transition-colors duration-300">Solutions</Link>
            <Link to="/project-experience" className="body-sm hover:text-text-primary transition-colors duration-300">Project Experience</Link>
          </div>

          {/* Column 3: More links */}
          <div className="flex flex-col gap-3">
            <span className="label-small mb-2">OPERATIONS</span>
            <Link to="/careers" className="body-sm hover:text-text-primary transition-colors duration-300">Careers</Link>
            <Link to="/contact" className="body-sm hover:text-text-primary transition-colors duration-300">Contact</Link>
            <a href="https://portal.stratongroup.co.za" className="body-sm hover:text-text-primary transition-colors duration-300">Command Center Login</a>
          </div>

          {/* Column 4: Services */}
          <div className="flex flex-col gap-3">
            <span className="label-small mb-2">DISCIPLINES</span>
            <Link to="/solutions" className="body-sm hover:text-text-primary transition-colors duration-300">Industrial Automation</Link>
            <Link to="/solutions" className="body-sm hover:text-text-primary transition-colors duration-300">Systems Integration</Link>
            <Link to="/solutions" className="body-sm hover:text-text-primary transition-colors duration-300">Global Deployment</Link>
          </div>
        </div>

        {/* Bottom row */}
        <div className="border-t border-border-secondary pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-xs text-text-muted">
            &copy; {new Date().getFullYear()} STRATON GROUP (PTY) LTD. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            <a href="/privacy-policy" className="relative z-20 text-xs text-text-muted hover:text-text-primary transition-colors duration-300 py-1">Privacy Policy</a>
            <a href="/terms-of-service" className="relative z-20 text-xs text-text-muted hover:text-text-primary transition-colors duration-300 py-1">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
